export const PHONE_NUMBER_PLACEHOLDER = '###phonenumber###';
export const MOBILE_LABEL = 'Chiama numero';
export const DESKTOP_LABEL = 'Mostra numero';
